// extracted by mini-css-extract-plugin
export default {"remind":"tNvyU","button":"Td7wJ","selected":"SYAPr","desc":"My5bG"};